import React from 'react';
import { Link } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import { authActions } from '../../../_services/essentials/store';
import FormControl from "@mui/material/FormControl";
import { Button, Grid, TextField, Box, Stack, Typography, Paper } from "@mui/material";
import { ArrowForwardOutlined } from '@mui/icons-material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useState } from 'react';
import useScreenSize from "../../../_components/UserScreenSize";

import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import SearchIcon from '@mui/icons-material/Search';
import PublicIcon from '@mui/icons-material/Public';
import BarChartIcon from '@mui/icons-material/BarChart';
import AddIcon from '@mui/icons-material/Add';
import LaunchIcon from '@mui/icons-material/Launch';

export { Login };

function Login() {
    const dispatch = useDispatch();

    const [showPassword, setShowPassword] = useState(false);
    const screenSize = useScreenSize();

    const handleTogglePassword = () => {
        setShowPassword(!showPassword);
    };
    // form validation rules 
    const validationSchema = Yup.object().shape({
        email: Yup.string()
            .required('Email is required')
            .email("Please enter a valid Email"),
        password: Yup.string().required('Password is required')
    });
    const formOptions = { resolver: yupResolver(validationSchema) };

    // get functions to build form with useForm() hook
    const { register, handleSubmit, formState } = useForm(formOptions);
    //    const { errors, isSubmitting } = formState;
    const { errors } = formState;

    function onSubmit({ email, password }) {
        return dispatch(authActions.login({ email, password }));
    }

    return (
        <Grid size={{ xs: 12, md: 5 }} sx={{ display: 'flex', justifyContent: { md: 'flex-end' } }}>
            <Paper
                elevation={0}
                sx={{
                    width: '100%',
                    maxWidth: '380px',
                    p: { xs: 2, md: 2 },
                    borderRadius: 4,
                    bgcolor: 'rgba(255, 255, 255, 0.95)',
                    boxShadow: '0 20px 40px rgba(0,0,0,0.3)',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    minHeight: '580px'
                }}
            >
            {/* Form Block */}
            <Box component="form" onSubmit={handleSubmit(onSubmit)}>
                <Typography variant="h5" component="h3" sx={{ fontWeight: 700, color: '#1a1068', mb: 0.5 }}>
                    Welcome back
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary', mb: 4 }}>
                    Sign in to your Oncoinsight account
                </Typography>

                <Stack spacing={3}>
                    <Box>
                        <Typography
                            variant="caption"
                            sx={{
                                fontWeight: 700,
                                color: 'text.secondary',
                                display: 'block',
                                mb: 1,
                                letterSpacing: 0.5
                            }}
                        >
                            EMAIL ADDRESS
                        </Typography>
                        <TextField
                            id="email"
                            type="text"
                            name="email"
                            placeholder="your@email.com"
                            autoComplete="off"
                            autoFocus
                            fullWidth
                            variant="outlined"
                            slotProps={{
                                input: {
                                    sx: { bgcolor: '#ffffff', borderRadius: 2, height: '40px' }
                                }
                            }}
                            {...register('email', { required: true })}
                            error={Boolean(errors.email)}
                            helperText={errors.email ? errors.email.message : ""}
                        />
                    </Box>

                    <Box>
                        <Typography
                            variant="caption"
                            sx={{
                                fontWeight: 700,
                                color: 'text.secondary',
                                display: 'block',
                                mb: 1,
                                letterSpacing: 0.5
                            }}
                        >
                            PASSWORD
                        </Typography>
                        <TextField
                            name="password"
                            placeholder="******"
                            // type="password"
                            type={showPassword ? 'text' : 'password'}
                            id="password"
                            autoComplete="off"
                            fullWidth
                            variant="outlined"
                            {...register('password', { required: true })}
                            error={Boolean(errors.password)}
                            helperText={errors.password ? errors.password.message : ""}
                            slotProps={{
                                input: {
                                    sx: { bgcolor: '#ffffff', borderRadius: 2, height: '40px' }
                                }
                            }}
                        />
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center', // Align items vertically in the center
                            mb: 4,
                            // Add margin-bottom for spacing
                        }}
                    >
                        <Link
                            to={"/account/register"}
                            variant="body2"
                            sx={{
                                alignSelf: 'center', cursor: 'pointer', fontFamily: 'Poppins, Arial, sans-serif',

                                textDecoration: 'none',
                                fontWeight: 500,
                            }}
                        >
                            Sign up
                        </Link>
                        <Link
                            to={"/account/forgot_password"}
                            variant="body2"
                            sx={{
                                alignSelf: 'center', cursor: 'pointer', fontFamily: 'Poppins, Arial, sans-serif',
                                textDecoration: 'none',
                                fontWeight: 500,
                            }}
                        >
                            Forgot your password?
                        </Link>


                    </Box>
                    {(screenSize.width < 1360) &&
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center', // Align items vertically in the center
                            alignContent: 'justify',
                            mb: 4,
                            width: '100%'
                            // Add margin-bottom for spacing
                        }}
                    ><Typography sx={{width: '100%', fontSize: '10px', color: 'red', alignContent: 'justify',}}>
                        Note: Your screen resolution is too small. Please increase it to at least 1360 x 768 for optimal viewing. Recommended screen resolution is 1920 x 1080.
                    </Typography>
                    </Box>
                    }
                    <Button
                        fullWidth
                        type="submit"
                        variant="contained"
                        endIcon={<ArrowForwardIcon />}
                        sx={{
                            height: '40px',
                            bgcolor: '#5c59dc',
                            '&:hover': { bgcolor: '#4a47c5' },
                            py: 1.5,
                            borderRadius: 2,
                            textTransform: 'none',
                            fontWeight: 600,
                            fontSize: '1rem',
                            mt: 1
                        }}
                    >
                        Sign In
                    </Button>
                </Stack>
            </Box>

            {/* Bottom Info Block */}
            <Box sx={{ mt: 4, pt: 3, borderTop: '1px solid #e0e0e0' }}>
                {/* Demo Credentials Box */}
                <Box sx={{ bgcolor: '#fff9e6', p: 2, borderRadius: 2, mb: 3, border: '1px solid #ffeeba' }}>
                    <Typography variant="caption" sx={{ fontWeight: 800, color: '#856404', display: 'block', mb: 0.5 }}>
                        DEMO CREDENTIALS
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#856404', fontFamily: 'monospace' }}>
                        <strong>Email:</strong> admin@oncoinsight.com
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#856404', fontFamily: 'monospace' }}>
                        <strong>Password:</strong> demo2026
                    </Typography>
                </Box>

                {/* Footer Brand Node */}
                <Stack direction="row" sx={{justifyContent:"space-between", alignItems:"center"}} >
                    <Stack direction="row" spacing={1} sx={{alignItems:"center"}}>
                        <Box
                            sx={{
                                width: 24,
                                height: 24,
                                bgcolor: '#333',
                                borderRadius: 0.5,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <Typography variant="caption" sx={{ color: '#fff', fontWeight: 'bold', fontSize: '0.6rem' }}>K</Typography>
                        </Box>
                        <Box>
                            <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', lineHeight: 1 }}>
                                Powered by
                            </Typography>
                            <Typography variant="caption" sx={{ fontWeight: 700, color: 'text.primary' }}>
                                Keyinsight Data Solutions
                            </Typography>
                        </Box>
                    </Stack>

                    <Link
                        to="https://keyinsightdata.com"
                        target="_self"
                        underline="hover"
                        sx={{
                            fontSize: '0.75rem',
                            color: '#5c59dc',
                            fontWeight: 600,
                            display: 'flex',
                            alignItems: 'center',
                            gap: 0.5
                        }}
                    >
                        Visit website <LaunchIcon sx={{ fontSize: 12 }} />
                    </Link>
                </Stack>
            </Box>
        </Paper>
    </Grid>
    )
}